<template>
<el-loading-wrapper
  tag="div"
  style="min-height: 100px;"
  class="notepad"
  :loading="loading"
  loading-text="Loading...">

  <notepad-header
    class="notepad-header"
    show-back-button
    @back-button-click="handleClose"
  >
    <template #notepad-header>
      <slot
        name="notepad-header"
      />
    </template>
  </notepad-header>
  <note-card
    v-test-id="'note-card'"
    v-if="showNoteCard"
    class="notepad-body"
    :editable="showAction"
    :deletable="showAction"
    :showActions="showActions"
    @edit-note-click="$emit('edit-note-click', currentNote)"
    @delete-note-click="onDeleteNoteClick"
    v-bind="getNoteProps(currentNote)"
    :history="currentNoteHistory"
    :history-loading="loadingHistory"
    >
    <template #note-breadcrumb>
      <slot
        name="note-breadcrumb"
        v-bind="{note: currentNote}"
      >
      </slot>
    </template>
    <template #note-title="props">
      <slot
        name="note-title"
        v-bind="props"
      />
    </template>
    <template #note-subtitle>
      <slot
        name="note-subtitle"
        v-bind="{note: currentNote}"
      />
    </template>
  </note-card>

</el-loading-wrapper>
</template>

<style lang="scss">
@import "./_notepad.scss";
</style>

<script>
import {mapActions, mapState, mapGetters} from 'vuex'
import notesActions from '#/notes/store/actionTypes'
import NoteCard from '#/notes/components/NoteCard'
import {NotesMixins} from '#/notes/components/mixins'
import NotepadHeader from '#/notes/components/NotepadHeader'

export default {
  name: 'NotepadDetails',
  components: {
    NoteCard,
    NotepadHeader
  },
  mixins: [NotesMixins],
  created () {
    this.loggedInUsername = this.userService.fetchLoggedInUsername()
  },
  data () {
    return {
      loading: false,
      loadingHistory: false,
      username: null
    }
  },
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    reference: {
      type: Object,
      default: null
    },
    showActions: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('notes', [
      'currentNote',
      'userService'
    ]),
    ...mapState('notes', [
      'currentNoteHistory'
    ]),
    referenceFilters () {
      // eslint-disable-next-line camelcase
      const {reference_id, reference_domain} = this.reference
      return {reference_id, reference_domain}
    },
    showAction () {
      if (this.currentNote) {
        return !this.currentNote.is_locked && this.currentNote.creator.username === this.loggedInUsername
      }
      return false
    },
    showNoteCard () {
      // As it takes some time for id watcher to fetch the note by id, we need to ensure the current note
      // contains more than just id if we wish to allow the display of note card.
      return this.currentNote && this.currentNote.creator
    }
  },
  watch: {
    'id': {
      async handler (id) {
        try {
          this.loading = true
          await this.fetchNoteById(id)
          this.loading = false
          this.$emit('note-detail-loaded', {note: this.currentNote})
          this.loadingHistory = true
          await this.fetchNoteHistory(id)
          this.loadingHistory = false
        } catch (error) {
          this.$message.error(error.message)
          this.handleClose()
          return
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      fetchNoteById: notesActions.FETCH_NOTE_BY_ID,
      fetchNoteHistory: notesActions.FETCH_NOTE_HISTORY,
      deleteNote: notesActions.DELETE_NOTE
    }),
    handleClose () {
      this.$emit('close')
    },
    onDeleteNoteClick () {
      this.$confirm('Are you sure you want to archive this note? This action is irreversible.')
        .then(async () => {
          await this.deleteNote({id: this.id, referenceFilters: this.referenceFilters})
            .then(() => {
              this.$message.success('The note was archived successfully')
            })
            .catch(() => {
              this.$message.error('There was an error archiving note')
            })
        })
        .catch(_ => {})
        .finally(() => this.handleClose())
    }
  }
}
</script>
